import React from 'react';
import { useLocation } from 'react-router-dom';
import { BottomNavigation } from './BottomNavigation';
import { CrystalBalance } from './CrystalBalance';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  // Страницы БЕЗ нижней навигации (например, формы с собственными кнопками)
  const pagesWithoutBottomNav = ['/journal/add', '/onboarding'];
  const showBottomNav = !pagesWithoutBottomNav.some(path => location.pathname.startsWith(path));


  return (
    <div className="app">
      <CrystalBalance />
      <div className={`app-content ${showBottomNav ? 'with-nav-only' : ''}`}>
        {children}
      </div>
      {showBottomNav && <BottomNavigation />}
    </div>
  );
};
